// extracted by mini-css-extract-plugin
export default {"container":"styles_container__bT9hY","centered":"styles_centered__CF7ON"};